@switch (filterType) {
    @case ('sortBy') {
        <div class="ng-filter-item sorts"
             [class.apply]="isApply"
             (click)="showFilterSheet()">
            <img class="ng-icon" src="/x-assets/img/icons/sort.svg" alt="sort icon" />
            <span class="ng-title">{{ filterPillLabel }}</span>

            @if (isApply) {
                <button type="button" class="btn-clear-filter" (click)="clearFilter($event)"></button>
            }
        </div>
    }

    @default {
        <div class="ng-filter-item"
             [class.apply]="isApply"
             (click)="showFilterSheet()">
            <span class="ng-title">{{ filterPillLabel }}</span>

            <!-- кнопка очистки: не триггерит родительский клик -->
            @if (isApply) {
                <button type="button" class="btn-clear-filter" (click)="clearFilter($event)"></button>
            }
        </div>
    }
}
